import { useLang } from "../i18n";

const ITEMS = {
  es: [
    "PUERTO RICO PREPARADO", "78 MUNICIPIOS", "NMEAD 787-724-0124",
    "LÍNEA PAS 1-800-981-0023", "TEMPORADA DE HURACANES: JUNIO A NOVIEMBRE",
    "EMERGENCIAS: 9-1-1", "AGUA: 1 GALÓN POR PERSONA POR DÍA",
  ],
  en: [
    "PUERTO RICO READY", "78 MUNICIPALITIES", "NMEAD 787-724-0124",
    "PAS LINE 1-800-981-0023", "HURRICANE SEASON: JUNE TO NOVEMBER",
    "EMERGENCIES: 9-1-1", "WATER: 1 GALLON PER PERSON PER DAY",
  ],
};

export function Marquee() {
  const { lang } = useLang();
  const items = ITEMS[lang];
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="no-print overflow-hidden border-y border-slate-300 bg-[#1C2B4A] py-3" aria-hidden="true">
      <div className="animate-marquee flex w-max items-center gap-8 whitespace-nowrap">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-8 font-mono-pr text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
            {item}
            <span className="text-amber-600">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
